<template>
  <b-container fluid style="background-color: #fff; border-radius: 15px">
    <b-alert
      variant="success"
      :show="dismissCountDownAdd"
      dismissible
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChangedAdd"
      >Successfully added new user to database...</b-alert
    >
    <b-alert
      variant="warning"
      :show="dismissCountDownRemove"
      dismissible
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChangedRemove"
      >Successfully removed subscriber role...</b-alert
    >
    <b-alert
      variant="success"
      :show="dismissCountDownAddRole"
      dismissible
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownChangedAddRole"
      >Successfully added subscriber role...</b-alert
    >
    <b-alert
      variant="success"
      :show="dismissCountDownFreeAccess"
      dismissible
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownFreeAccess"
      >Successfully alloted User Free type...</b-alert
    >
    <b-alert
      variant="success"
      :show="dismissCountDownMessageUsers"
      dismissible
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownMessageFreeAccessUsers"
      >Successfully messaged users with free access...</b-alert
    >
    <b-alert
      variant="success"
      :show="dismissCountDownRemoveAllUsers"
      dismissible
      @dismissed="dismissCountDown = 0"
      @dismiss-count-down="countDownRemoveFreeAccessUsers"
      >Successfully removed users with free access...</b-alert
    >

    <b-row>
      <b-col lg="2" class="my-4">
        Users:
        {{ filteredItems.length > 0 ? filteredItems.length : items.length }}
      </b-col>
      <b-col lg="4" class="my-4">
        <!-- <b-form-group
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >-->
        <b-input-group prepend="Search" size="sm">
          <b-form-input
            v-model="filter"
            @keyup="filteredUsers()"
            @click="filteredUsers()"
            @change="filteredUsers()"
            type="search"
            id="filterInput"
          ></b-form-input>
        </b-input-group>
        <!-- </b-form-group> -->
      </b-col>

      <b-col lg="6" class="my-4">
        <b-row>
          <b-button
            size="sm"
            variant="success"
            style="margin-right: 15px"
            v-b-modal.add-user
            >Add New User</b-button
          >

          <b-button
            size="sm"
            variant="warning"
            name="paypal"
            style="margin-right: 15px"
            @click="filterByProcessor"
            >Show Paypal Only</b-button
          >

          <b-button
            size="sm"
            variant="info"
            name="stripe"
            style="margin-right: 15px"
            @click="filterByProcessor"
            >Show Stripe Only</b-button
          >

          <b-button
            size="sm"
            variant="secondary"
            name="showAll"
            style="margin-right: 15px"
            @click="filterByProcessor"
            >Show All</b-button
          >

          <b-button
            size="sm"
            variant="danger"
            name="expiredAccess"
            style="margin-right: 15px"
            @click="filterByProcessor"
            >Show Members With Expired Access</b-button
          >
        </b-row>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="6"> </b-col>

      <b-col lg="6">
        <b-row>
          <b-button
            size="sm"
            variant="success"
            name="mesageMembersWithFreeAccess"
            style="margin-right: 15px"
            @click="filterByProcessor"
          >
            Mesage Members With Expired Access
          </b-button>

          <b-button
            size="sm"
            variant="danger"
            name="removeAllUsers"
            style="margin-right: 15px"
            @click="filterByProcessor"
          >
            Remove All Members With Expired Access
          </b-button>
        </b-row>
      </b-col>
    </b-row>

    <!-- add new user form -->
    <b-modal
      id="add-user"
      ref="add-user"
      title="Add new user to database"
      size="lg"
      hide-footer
    >
      <b-form @submit="submitNewUser">
        <!-- <b-form-group 
        id="input-group-9" 
        label="Customer ID:" 
        label-for="input-9"
        >
          <b-form-input id="input-9" v-model="form.customerId" placeholder="Enter Stripe Customer ID"></b-form-input>
        </b-form-group> -->

        <b-form-group
          id="input-group-5"
          label="Subscription ID:"
          label-for="input-5"
        >
          <b-form-input
            id="input-5"
            v-model="form.subscriptionId"
            placeholder="Enter Subscription ID"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-1" label="Email:" label-for="input-1">
          <b-form-input id="input-1" v-model="email" required></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="Name:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.name"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" label="Processor:" label-for="input-3">
          <b-form-select
            id="input-3"
            v-model="form.processor"
            :options="processorOptions"
            required
          ></b-form-select>
        </b-form-group>

        <!-- <b-form-group
          id="input-group-5"
          label="Subscription ID:"
          label-for="input-5"
        >
          <b-form-input
            id="input-5"
            v-model="form.subscriptionId"
            required
          ></b-form-input>
        </b-form-group> -->

        <b-form-group
          id="input-group-6"
          label="Customer ID:"
          label-for="input-6"
          v-if="form.processor === 'stripe'"
        >
          <b-form-input
            id="input-6"
            v-model="form.customerId"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-7"
          label="Membership Type:"
          label-for="input-7"
        >
          <b-form-select
            id="input-7"
            v-model="form.type"
            :options="typeOptions"
            required
          ></b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-8"
          label="Next Payment:"
          label-for="input-8"
        >
          <b-form-datepicker
            id="input-group-8"
            v-model="form.nextPayment"
            class="mb-2"
            required
          ></b-form-datepicker>
        </b-form-group>

        <b-button type="submit" variant="primary">Submit</b-button>
        <b-button id="fetch_stripe_id" @click="fetch_stripe_customer_details">Fetch Stripe Customer Details</b-button>
      </b-form>
    </b-modal>

    <!-- edit user details form -->
    <b-modal
      id="edit-user"
      ref="edit-user"
      title="Edit User Details"
      size="lg"
      hide-footer
    >
      <b-form @submit="updateExistingUser">
        <b-form-group id="input-group-9" label="Email:" label-for="input-1">
          <b-form-input
            id="input-9"
            v-model="userUpdateForm.email"
            readonly
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-10"
          label="Discord ID:"
          label-for="input-5"
        >
          <b-form-input
            id="input-10"
            v-model="userUpdateForm.discordId"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-11"
          label="Subscription ID:"
          label-for="input-5"
        >
          <b-form-input
            id="input-11"
            v-model="userUpdateForm.subscriptionId"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-12"
          label="Processor:"
          label-for="input-3"
        >
          <b-form-select
            id="input-12"
            v-model="userUpdateForm.processor"
            :options="processorOptions"
            required
          ></b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-15"
          label="Customer ID:"
          label-for="input-15"
          v-if="userUpdateForm.processor === 'stripe'"
        >
          <b-form-input
            id="input-15"
            v-model="userUpdateForm.customerId"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-14"
          label="Prevent Trial Loop:"
          label-for="input-5"
        >
          <b-form-radio
            v-model="userUpdateForm.preventTrialLoop"
            name="some-radios"
            value="true"
            >True</b-form-radio
          >
          <b-form-radio
            v-model="userUpdateForm.preventTrialLoop"
            name="some-radios"
            value="false"
            >False</b-form-radio
          >
        </b-form-group>

        <b-form-group
          id="input-group-33"
          label="Discord Bound:"
          label-for="input-33"
        >
          <b-form-radio
            v-model="userUpdateForm.discordBound"
            name="some-radios-discord"
            value="true"
            >True</b-form-radio
          >
          <b-form-radio
            v-model="userUpdateForm.discordBound"
            name="some-radios-discord"
            value="false"
            >False</b-form-radio
          >
        </b-form-group>

        <b-form-group
          id="input-group-27"
          label="Membership Type:"
          label-for="input-7"
        >
          <b-form-select
            id="input-27"
            v-model="userUpdateForm.type"
            :options="typeOptions"
            required
          ></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-32" label="Status:" label-for="input-32">
          <b-form-select
            id="input-32"
            v-model="userUpdateForm.status"
            :options="statusOptions"
            required
          ></b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-28"
          label="Trading View:"
          label-for="input-5"
        >
          <b-form-input
            id="input-28"
            v-model="userUpdateForm.tradingView"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-29" label="Name:" label-for="input-5">
          <b-form-input
            id="input-29"
            v-model="userUpdateForm.name"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-30"
          label="Phone Number:"
          label-for="input-5"
        >
          <b-form-input
            id="input-30"
            v-model="userUpdateForm.phoneNumber"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-31"
          label="Next Payment:"
          label-for="input-31"
        >
          <b-form-datepicker
            id="input-group-31"
            v-model="userUpdateForm.nextPayment"
            class="mb-2"
            required
          ></b-form-datepicker>
        </b-form-group>

        <b-button type="submit" variant="primary">Update</b-button>
      </b-form>
    </b-modal>

    <!-- remove user form -->
    <b-modal
      id="remove-user"
      ref="remove-user"
      title="Remove user 'Subscriber' role on a specific date"
      size="lg"
      hide-footer
    >
      <b-form @submit="removeExistingUser">
        <b-form-group id="input-group-15" label="Email:" label-for="input-15">
          <b-form-input
            id="input-15"
            v-model="userRemoveForm.email"
            readonly
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-16"
          label="Discord ID:"
          label-for="input-16"
        >
          <b-form-input
            id="input-16"
            v-model="userRemoveForm.discordId"
            readonly
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-17"
          label="Select date:"
          label-for="input-17"
        >
          <b-form-datepicker
            id="input-group-17"
            v-model="userRemoveForm.date"
            class="mb-2"
            :min="minDate"
            required
          ></b-form-datepicker>
        </b-form-group>

        <b-button type="submit" variant="primary">Submit</b-button>
      </b-form>
    </b-modal>

    <!-- unsubscribe user payment method form -->
    <b-modal
      id="unsubscribe-user"
      ref="unsubscribe-user"
      title="Are you sure you want to unsubscribe user payment method?"
      size="lg"
      hide-footer
    >
      <b-form @submit="unsubscribeUserPaymentMethodSubmit">
        <b-form-group
          id="input-group-12"
          label="Payment Processor:"
          label-for="input-3"
        >
          <b-form-select
            id="input-12"
            v-model="unsubscribeUserPaymentForm.processor"
            :options="processorOptions"
            :disabled="true"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          id="input-group-16"
          label="Subscription ID:"
          label-for="input-16"
        >
          <b-form-input
            id="input-16"
            v-model="unsubscribeUserPaymentForm.subscriptionId"
            readonly
          ></b-form-input>
        </b-form-group>

        <b-button type="submit" variant="success" class="mb-2"
          >Unsubscribe</b-button>
        <b-button
          variant="danger"
          class="mb-2 ml-2"
          @click="$bvModal.hide('unsubscribe-user')"
          >Cancel</b-button
        >
      </b-form>
    </b-modal>

    <b-table
      striped
      hover
      bordered
      head-variant="dark"
      light
      sticky-header
      no-border-collapse
      responsive
      :items="items"
      :fields="fields"
      :filter="filter"
      :busy="!dataLoaded"
      style="max-height: 100%; min-height: 300px; margin-top: 10px"
    >
      <template v-slot:table-busy>
        <div>
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <b-dropdown
          id="dropdown-1"
          text="Actions"
          class="m-md-1"
          variant="danger"
          size="sm"
        >
          <b-dropdown-item v-on:click="editUser(row)" v-b-modal.edit-user
            >Edit User</b-dropdown-item
          >

          <b-dropdown-item @click="addRole(row)">Add Role</b-dropdown-item>

          <b-dropdown-item @click="removeRole(row)"
            >Remove Role</b-dropdown-item
          >

          <b-dropdown-item
            @click="removeUserOnSpecificDate(row)"
            v-b-modal.remove-user
            >Remove User</b-dropdown-item
          >

          <b-dropdown-item
            @click="unsubscribeUserPaymentMethod(row)"
            v-b-modal.unsubscribe-user
            v-if="user.type === 'admin'"
            >Unsubscribe Payment</b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <!-- Password Modal for FreeAccess -->
    <b-modal
      id="password-modal"
      ref="password-modal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      title="Enter Password"
    >
      <b-form @submit="checkPassword">
        <b-form-group id="input-group-9" label="Password:" label-for="input-1">
          <b-form-input
            id="input-9"
            v-model="enter_password"
            type="password"
            :state="verifyPassword"
            aria-describedby="input-live-feedback"
            placeholder="Enter Password"
          >
          </b-form-input>
          <b-form-invalid-feedback id="input-live-feedback">
            Enter Corret Password
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button type="submit" variant="primary">Submit</b-button>
        <b-button
          variant="outline-danger"
          class="float-right"
          @click="hidePasswordModal"
          >Cancel</b-button
        >
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
import axios from "axios";
import { FireSQL } from "firesql";
import db from "../../database";
const collection = db.collection("users");
const fireSQL = new FireSQL(db);
// const { LocalServerUrl } = require('../config/config.json');

export default {
  name: "Admin",
  metaInfo: {
    title: "Market Moves - Dashboard",
    titleTemplate: "Dashboard",
  },
  computed: {
    verifyPassword() {
      return this.enter_password === this.store_password ? true : false;
    },
  },
  data() {
    return {
      discord: {},
      user: {},
      dataLoaded: false,
      filter: null,
      items: [],
      filteredItems: [],
      filtered: false,
      fields: [
        {
          key: "email",
          label: "Email",
        },
        {
          key: "discordId",
          label: "Discord ID",
        },
        {
          key: "processor",
          label: "Processor",
        },
        {
          key: "subscriptionId",
          label: "Subscription ID",
        },
        {
          key: "type",
          label: "Type",
        },
        {
          key: "nextPayment",
          label: "Next Payment Date",
          sortable: true,
        },
        {
          key: "tos_esign",
          label: "TOS Sign",
          tdClass: "maxColumnWidth",
          thStyle: { width: "210px" },
        },
        {
          key: "actions",
          label: "Actions",
        },
      ],
      form: {
        ccLast4: "",
        ccMonth: "",
        ccYear: "",
        ccType: "",
        customerId: "",
        discordBound: false,
        discordId: "",
        name: "",
        nextPayment: null,
        phoneNumber: "",
        processor: "",
        status: "active",
        subscriptionId: "",
        tos_esign: "",
        type: "",
        tradingView: "",
        preventTrialLoop: false,
      },
      userUpdateForm: {
        email: "",
        discordId: "",
        subscriptionId: "",
        processor: "",
        preventTrialLoop: "",
        customerId: "",
        type: "",
        tradingView: "",
        name: "",
        phoneNumber: "",
        nextPayment: null,
        status: "",
        discordBound: false,
        allItemsFilter: true,
      },
      userRemoveForm: {
        email: "",
        discordId: "",
        date: "",
      },
      unsubscribeUserPaymentForm: {
        email: "",
        subscriptionId: "",
        processor: "",
      },
      email: "",
      processorOptions: [
        { value: "paypal", text: "Paypal" },
        { value: "stripe", text: "Stripe" },
      ],
      typeOptions: [
        { value: "trial", text: "Trial" },
        { value: "member", text: "Member" },
        { value: "inactive", text: "Inactive" },
        { value: "free", text: "Free" },
      ],
      statusOptions: [
        { value: "active", text: "Active" },
        { value: "canceled", text: "Canceled" },
      ],
      dismissSecs: 5,
      dismissCountDownAdd: 0,
      dismissCountDownRemove: 0,
      dismissCountDownAddRole: 0,
      dismissCountDownFreeAccess: 0,
      dismissCountDownMessageUsers: 0,
      dismissCountDownRemoveAllUsers: 0,
      minDate: new Date(),
      typingTimer: null,
      doneTypingInterval: 2000,
      store_password: "marketmoves",
      enter_password: "",
    };
  },
  async mounted() {
    if (!this.$cookies.get("session_token")) this.$router.push({ path: "/" });

    // Retrieve user data
    await this.fetchDiscordData();
    await this.fetchUserData();
    await this.fetchUserbase();

    console.log("User ", this.user)
    if (this.user.type === 'admin') {
      this.typeOptions.push({ value: "sub-admin", text: "Sub-admin" })
    }

    this.dataLoaded = true;
  },
  methods: {
    async fetchDiscordData() {
      const token = {
        session_token: this.$cookies.get("session_token"),
      };
      return axios
        .post(
          "https://us-central1-market-moves.cloudfunctions.net/app/api/verify",
          token
        )
        .then((user) => {
          this.discord = user.data;
        })
        .catch((err) => console.error(err));
    },
    async fetchUserData() {
      return collection
        .where("discordId", "==", this.discord.id)
        .get()
        .then((snap) =>
          snap.forEach((doc) => {
            if (doc.exists && (doc.data().type === "admin" || doc.data().type === "sub-admin")) {
              this.user = doc.data();
            } else {
              this.$router.push({ path: "/" });
            }
          })
        );
    },
    async fetchUserbase() {
      return collection
        .where("status", "==", "active")
        .get()
        .then((snap) => {
          this.allItemsFilter = true;
          this.dataLoaded = true;
          this.items = [];
          this.filteredItems = [];
          snap.forEach((doc) => {
            let obj = {
              email: doc.id,
              discordId: doc.data().discordId,
              processor: doc.data().processor,
              subscriptionId: doc.data().subscriptionId,
              type: doc.data().type,
              nextPayment: this.convertUnix(doc.data().nextPayment),
              discordBound: doc.data().discordBound,
              tradingView: doc.data().tradingView,
              preventTrialLoop: doc.data().preventTrialLoop,
              customerId: doc.data().customerId,
              name: doc.data().name,
              phoneNumber: doc.data().phoneNumber,
              status: doc.data().status,
              tos_esign: doc.data().tos_esign,
            };
            this.items.push(obj);
            obj = {};
          });
          this.filteredItems = [...this.items];
        });
    },
    async searchUserWithEmail(string) {
      if (string == "" || string == null) {
        // if string is blank
        await this.fetchUserbase();
      } else {
        this.dataLoaded = false;

        const users = await fireSQL.query(
        `
          SELECT * 
          FROM users 
          WHERE discordId LIKE '${string.toLowerCase()}%' OR __name__ LIKE '${string.toLowerCase()}%'
        `,
          { includeId: "id" }
        );

        // usersPromise.then(users => {
        if (users) {
          this.dataLoaded = true;
          this.items = [];
          for (const user of users) {
            let obj = {
              email: user.id,
              discordId: user.discordId,
              processor: user.processor,
              subscriptionId: user.subscriptionId,
              type: user.type,
              nextPayment: this.convertUnix(user.nextPayment),
              discordBound: user.discordBound,
              tradingView: user.tradingView,
              preventTrialLoop: user.preventTrialLoop,
              customerId: user.customerId,
              name: user.name,
              phoneNumber: user.phoneNumber,
              status: user.status,
              tos_esign: user.tos_esign,
            };
            this.items.push(obj);
            obj = {};
          }
        } else {
          this.dataLoaded = true;
        }
        // });

        if (this.items) {
          this.filtered = true;
          this.filter = this.filter.toLowerCase();
          this.filteredItems = this.items.filter((item) => {
            return (
              item.processor.includes(this.filter) ||
              item.email.includes(this.filter) ||
              item.discordId.includes(this.filter) ||
              item.subscriptionId.includes(this.filter) ||
              item.type.includes(this.filter) ||
              item.nextPayment.includes(this.filter)
            );
          });
        } else {
          this.filteredItems = [];
        }
      }
    },
    async getUsersWithExpiredAccess() {
      return axios
        .get(
          // `${LocalServerUrl}app/api/findMembersWithFreeAccess/members`
          "https://us-central1-market-moves.cloudfunctions.net/app/api/findMembersWithFreeAccess/members"
        )
        .then((user) => {
          if (user.data.membersWithFreeAcces) {
            this.allItemsFilter = false;
            this.dataLoaded = true;
            this.items = [];
            this.filteredItems = [];
            user.data.membersWithFreeAcces.forEach((doc) => {
              let obj = {
                email: doc.email,
                discordId: doc.discordId,
                processor: doc.processor,
                subscriptionId: doc.subscriptionId,
                type: doc.type,
                nextPayment: this.convertUnix(doc.nextPayment),
                discordBound: doc.discordBound,
                tradingView: doc.tradingView,
                preventTrialLoop: doc.preventTrialLoop,
                customerId: doc.customerId,
                name: doc.name,
                phoneNumber: doc.phoneNumber,
                status: doc.status,
                tos_esign: doc.tos_esign,
              };
              this.items.push(obj);
              obj = {};
            });
            this.filteredItems = [...this.items];
          }
        })
        .catch((err) => {
          this.dataLoaded = true;
          console.error("err==", err);
        });
    },
    async fetch_stripe_customer_details() {
      console.log(this.form.subscriptionId)

      // const elements = stripe.elements();
      if (this.form.subscriptionId != "") {

        axios.get('https://us-central1-market-moves.cloudfunctions.net/app/api/stripe/customerdetails', {
          params: {
            q: this.form.subscriptionId
          }
        }).then((res) =>{
          let customer_data = res.data

          // this.form.customerId = this.stripe_customer_id
          this.form.processor = "stripe"
          this.form.name = customer_data.name
          this.email = customer_data.email.toLowerCase()
          this.form.customerId = customer_data.customer_id

          let user_date = new Date(customer_data.nextPayment * 1000).toLocaleDateString()
          let date_list = user_date.split("/")
          this.form.nextPayment = `${date_list[2]}-${date_list[0]}-${date_list[1]}`

        })
        .catch((err) => console.log(err))


      }
    },
    async sendMesageToMembersWithFreeAccess() {
       return axios
        .get(
          // "http://localhost:5001/market-moves/us-central1/app/api/message/members"
          "https://us-central1-market-moves.cloudfunctions.net/app/api/message/members",
        )
        .then((response) => {
          if(response) {
            this.dismissCountDownMessageUsers = this.dismissSecs;
          }
        })
        .catch((err) => {
          // this.dataLoaded = true;
          console.error("err==", err);
        });
    },
    async removeAllUsersWithFreeAccess() {
      console.log("Func called");
      this.$refs["password-modal"].show();
    },
    hidePasswordModal() {
      // Hide Password Modal
      this.$refs["password-modal"].hide();

      // CLear All Text
      this.enter_password = "";
    },
    async checkPassword(e) {
      e.preventDefault();
      // Check if some value enter in textbox
      if (this.enter_password.length > 0) {
        // IF ENter Password is same as store_password
        if (this.enter_password === this.store_password) {
          // Clear Password Variable
          this.enter_password = "";
          // Hide model when password is corret
          this.$refs["password-modal"].hide();

          // Call API here
          console.log("Password entered is correct");
           return axios
            .get(
              // "http://localhost:5001/market-moves/us-central1/app/api/remove/members"
              "https://us-central1-market-moves.cloudfunctions.net/app/api/remove/members",
            )
            .then((response) => {
              if(response) {
                this.dismissCountDownRemoveAllUsers = this.dismissSecs;
              }
            })
            .catch((err) => {
              // this.dataLoaded = true;
              console.error("err==", err);
            });
        }
      }
    },
    convertUnix(ts) {
      let date = new Date(ts * 1000);
      const month = date.toLocaleString("en-US", { month: "long" });
      const day = date.toLocaleString("en-US", { day: "numeric" });
      const year = date.toLocaleString("en-US", { year: "numeric" });
      return month + " " + day + ", " + year;
    },
    // renderAddRoleBtn(row) {
    //   if (row.item.discordBound === true) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // renderRemoveRoleBtn(row) {
    //   if (row.item.discordBound !== true) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // renderRemoveUserBtn(row) {
    //   if (row.item.discordBound !== true) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    editUser(row) {
      if (row) {
        // patch user update form
        this.userUpdateForm.email = row.item.email;
        this.userUpdateForm.discordId = row.item.discordId;
        this.userUpdateForm.subscriptionId = row.item.subscriptionId;
        this.userUpdateForm.processor = row.item.processor;
        this.userUpdateForm.preventTrialLoop = row.item.preventTrialLoop;
        this.userUpdateForm.customerId = row.item.customerId;
        this.userUpdateForm.tradingView = row.item.tradingView;
        this.userUpdateForm.name = row.item.name;
        this.userUpdateForm.type = row.item.type;
        this.userUpdateForm.phoneNumber = row.item.phoneNumber;
        this.userUpdateForm.nextPayment = new Date(row.item.nextPayment);
        this.userUpdateForm.status = row.item.status;
        this.userUpdateForm.discordBound = row.item.discordBound;
      }
    },
    filteredUsers() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.searchUserWithEmail(this.filter);
      }, this.doneTypingInterval);
    },
    async filterByProcessor(e) {
      const name = e.target.name;

      switch (name) {
        case "paypal":
          if (this.allItemsFilter) {
            this.filtered = false;
            this.filteredItems = [];
            this.items = [];
            this.dataLoaded = false;
            await this.fetchUserbase();
          }

          if (this.items) {
            this.filtered = true;
            this.filteredItems = this.items.filter((item) => {
              return item.processor.includes("paypal");
            });
          }
          this.filter = "paypal";
          break;

        case "stripe":
          if (this.allItemsFilter) {
            this.filtered = false;
            this.filteredItems = [];
            this.items = [];
            this.dataLoaded = false;
            await this.fetchUserbase();
          }

          if (this.items) {
            this.filtered = true;
            this.filteredItems = this.items.filter((item) => {
              return item.processor.includes("stripe");
            });
          }
          this.filter = "stripe";
          break;

        case "showAll":
          this.filtered = false;
          this.filteredItems = [];
          this.items = [];
          this.dataLoaded = false;
          await this.fetchUserbase();
          this.filter = null;
          break;

        case "expiredAccess":
          this.filtered = false;
          this.filteredItems = [];
          this.items = [];
          this.dataLoaded = false;
          // call API to get users with expired access
          await this.getUsersWithExpiredAccess();
          this.filter = null;
          break;

        case "mesageMembersWithFreeAccess":
          // call API to sendMesageToMembersWithFreeAccess
          await this.sendMesageToMembersWithFreeAccess();
          break;

        case "removeAllUsers":
          // call API to removeAllUsersWithFreeAccess
          await this.removeAllUsersWithFreeAccess();
          break;
      }
    },
    async updateExistingUser(e) {
      e.preventDefault();

      this.userUpdateForm.nextPayment = Math.floor(
        new Date(this.userUpdateForm.nextPayment) / 1000
      );

      await collection
        .doc(this.userUpdateForm.email.toLowerCase())
        .get()
        .then(async (doc) => {
          if (doc.exists) {
            let payload = {
              discordId: this.userUpdateForm.discordId,
              subscriptionId: this.userUpdateForm.subscriptionId,
              processor: this.userUpdateForm.processor,
              preventTrialLoop: this.userUpdateForm.preventTrialLoop,
              customerId: this.userUpdateForm.customerId,
              tradingView: this.userUpdateForm.tradingView,
              name: this.userUpdateForm.name,
              type: this.userUpdateForm.type,
              phoneNumber: this.userUpdateForm.phoneNumber,
              nextPayment: this.userUpdateForm.nextPayment,
              status: this.userUpdateForm.status,
              discordBound: this.userUpdateForm.discordBound,
            };

            // if email exists update the user details
            await collection
              .doc(this.userUpdateForm.email.toLowerCase())
              .update(payload);

            // Update local view after user details are updated
            this.items.forEach((item) => {
              if (item.email == this.userUpdateForm.email.toLowerCase()) {
                (item.discordId = this.userUpdateForm.discordId),
                  (item.subscriptionId = this.userUpdateForm.subscriptionId),
                  (item.processor = this.userUpdateForm.processor),
                  (item.preventTrialLoop = this.userUpdateForm.preventTrialLoop),
                  (item.customerId = this.userUpdateForm.customerId),
                  (item.tradingView = this.userUpdateForm.tradingView),
                  (item.name = this.userUpdateForm.name),
                  (item.type = this.userUpdateForm.type),
                  (item.phoneNumber = this.userUpdateForm.phoneNumber),
                  (item.nextPayment = this.convertUnix(
                    this.userUpdateForm.nextPayment
                  )),
                  (item.status = this.userUpdateForm.status),
                  (item.discordBound = this.userUpdateForm.discordBound);
              }
            });
          }
        })
        .catch((err) => console.error(err));

      this.$refs["edit-user"].hide();
    },
    async submitNewUser(e) {
      e.preventDefault();

      this.dismissCountDownAdd = this.dismissSecs;
      this.form.nextPayment = Math.floor(
        new Date(this.form.nextPayment) / 1000
      );

      await collection
        .doc(this.email.toLowerCase())
        .get()
        .then(async (doc) => {
          if (doc.exists) {
            let payload = {
              name: this.form.name,
              processor: this.form.processor,
              subscriptionId: this.form.subscriptionId,
              type: this.form.type,
              nextPayment: this.form.nextPayment,
              status: "active",
              preventTrialLoop: false,
            };

            if (this.form.processor === "stripe") {
              payload.customerId = this.form.customerId;
            }

            // if email already exists update
            await collection.doc(this.email.toLowerCase()).update(payload);

            // Update local view
            this.items.push({
              discordBound: false,
              discordId: "",
              email: this.email,
              nextPayment: this.convertUnix(this.form.nextPayment),
              processor: this.form.processor,
              subscriptionId: this.form.subscriptionId,
              type: this.form.type,
            });
          } else {
            // If email does not exist yet then set
            await collection.doc(this.email.toLowerCase()).set(this.form);

            // Update local view
            this.items.push({
              discordBound: false,
              discordId: "",
              email: this.email,
              nextPayment: this.convertUnix(this.form.nextPayment),
              processor: this.form.processor,
              subscriptionId: this.form.subscriptionId,
              type: this.form.type,
            });
          }
        })
        .catch((err) => console.error(err));

      // reset form
      this.email = "";
      this.form.name = "";
      this.form.processor = "";
      this.form.subscriptionId = "";
      this.form.customerId = "";
      this.form.type = "";
      this.form.nextPayment = "";

      this.$refs["add-user"].hide();
    },
    async removeRole(row) {
      const email = row.item.email;
      const discordId = row.item.discordId;

      await axios({
        method: "POST",
        url:
          // "http://localhost:5001/market-moves/us-central1/app/api/role/remove",
          "https://us-central1-market-moves.cloudfunctions.net/app/api/role/remove",
        data: {
          email,
          discordId,
        },
      }).catch((err) =>
        console.error(err, "error sending role removal command to zapier")
      );

      this.dismissCountDownRemove = this.dismissSecs;
    },
    async addRole(row) {
      const email = row.item.email;
      const discordId = row.item.discordId;

      await axios({
        method: "POST",
        url:
          // "http://localhost:5001/market-moves/us-central1/app/api/role/addRole",
          "https://us-central1-market-moves.cloudfunctions.net/app/api/role/addRole",
        data: {
          email,
          discordId,
        },
      }).catch((err) =>
        console.error(err, "error sending add role command to zapier")
      );

      this.dismissCountDownAddRole = this.dismissSecs;
    },
    async removeUserOnSpecificDate(row) {
      // patch user remove form
      this.userRemoveForm.email = row.item.email;
      this.userRemoveForm.discordId = row.item.discordId;
    },
    async removeExistingUser(e) {
      e.preventDefault();

      if (!this.userRemoveForm.date) {
        alert("Please select date");
        return;
      }

      const email = this.userRemoveForm.email;
      const discordId = this.userRemoveForm.discordId;
      const date = new Date(this.userRemoveForm.date).getTime() / 1000;

      await axios({
        method: "POST",
        url:
          // "http://localhost:5001/market-moves/us-central1/app/api/user/removeUserOnSpecificDate",
          "https://us-central1-market-moves.cloudfunctions.net/app/api/user/removeUserOnSpecificDate",
        data: {
          email,
          discordId,
          date,
        },
      }).catch((err) =>
        console.error(err, "error sending add role command to zapier")
      );

      // reset form
      this.userRemoveForm.email = "";
      this.userRemoveForm.discordId = "";
      this.userRemoveForm.date = null;

      this.$refs["remove-user"].hide();
    },
    async unsubscribeUserPaymentMethod(row) {
      // patch user remove form
      if (this.user.type === 'admin') {
      this.unsubscribeUserPaymentForm.email = row.item.email;
      this.unsubscribeUserPaymentForm.processor = row.item.processor;
      this.unsubscribeUserPaymentForm.subscriptionId = row.item.subscriptionId;
      }
    },
    async unsubscribeUserPaymentMethodSubmit(e) {
      e.preventDefault();

      // user payment processor 'paypal'
      if (this.unsubscribeUserPaymentForm.processor === "paypal") {
        // Paypal subscription details
        const payload = {
          paymentId: this.unsubscribeUserPaymentForm.subscriptionId,
        };

        // Make subscription cancel request to Paypal API
        await axios
          .post(
            // "http://localhost:5001/market-moves/us-central1/app/api/paypal/cancel", payload)
            "https://us-central1-market-moves.cloudfunctions.net/app/api/paypal/cancel",
            payload
          )
          .then(async () => {
            await collection
              .where("email", "==", this.unsubscribeUserPaymentForm.email)
              .get()
              .then((snap) =>
                snap.forEach(async (doc) => {
                  await collection.doc(doc.id).update({ status: "canceled" });
                })
              );
            alert("Subscription successfully canceled!");
          })
          .catch(() => alert("Unexpected error has occured"));
      } else {
        // user payment processor 'stripe'
        const { subscriptionId } = this.unsubscribeUserPaymentForm;
        const cancelOptions = {
          url: `https://us-central1-market-moves.cloudfunctions.net/app/api/stripe/cancel`,
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          data: {
            subscription_id: subscriptionId,
          },
        };

        // Send a post request to Stripe's API to cancel subscription at period end
        await axios(cancelOptions)
          .then(async () => {
            await collection
              .where("email", "==", this.unsubscribeUserPaymentForm.email)
              .get()
              .then((snap) =>
                snap.forEach(async (doc) => {
                  await collection.doc(doc.id).update({ status: "canceled" });
                })
              );
            alert("Subscription successfully canceled!");
          })
          .catch(() =>
            alert(
              "Unexpected error occured. Subscription has already been canceled."
            )
          );
      }

      this.$refs["unsubscribe-user"].hide();
    },
    countDownChangedAdd(dismissCountDown) {
      this.dismissCountDownAdd = dismissCountDown;
    },
    countDownChangedRemove(dismissCountDown) {
      this.dismissCountDownRemove = dismissCountDown;
    },
    countDownChangedAddRole(dismissCountDown) {
      this.dismissCountDownAddRole = dismissCountDown;
    },
    countDownFreeAccess(dismissCountDown) {
      this.dismissCountDownFreeAccess = dismissCountDown;
    },
    countDownMessageFreeAccessUsers(dismissCountDown) {
      this.dismissCountDownMessageUsers = dismissCountDown;
    },
    countDownRemoveFreeAccessUsers(dismissCountDown) {
      this.dismissCountDownRemoveAllUsers = dismissCountDown;
    },
  },
};
</script>

<style scoped>
.maxColumnWidth {
  max-width: 300px !important;
}
</style>